import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import StyleStore from 'src/app/infrastructure/store/style.store';
import { Style } from 'src/app/infrastructure/style/style';
import { WebComponent } from 'src/app/ui/webapp/component/web.component';

@Component({
  selector: 'app-customer-area',
  templateUrl: 'customer-area-layout.page.html',
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    class: 'w-full h-full block',
  },
})
export class CustomerAreaLayoutPage extends WebComponent {
  public style: Style;
  public showBackButton = true;

  constructor(
    private styleStore: StyleStore,
    private readonly route: ActivatedRoute,
  ) {
    super();
  }

  protected onInit() {
    super.onInit();

    this.showBackButton = this.route.snapshot.data.hideBackButton !== true;

    this.subscribe(
      this.styleStore.style$,
      (style) => this.style = style
    );
  }
}
